import moment from "moment";
import { FIELD_ICON } from "../styles/media";
import { FIELDS, CITIES } from "../utils/constants";
import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import useDistrictNameByCityAndId from "../helpers/useDistrictNameByCityAndId";
import { UserContext } from "../../App";
import { getApp, getApps, initializeApp } from "firebase/app";
import {getDatabase, onChildAdded, push, ref} from "firebase/database";
import { firebaseConfig } from "../utils/constants";
import { useTranslation } from "react-i18next";

const WorkerCard = ({worker}) => {
    const {t,i18n} = useTranslation();
    const {fields} = useContext(UserContext);
    const [commentsList, setCommentsList] = useState([]);

    useEffect(()=>{
        if(moment) {
            moment?.locale('en-US');
        }
    },[])


    useEffect(()=>{
        if(!worker?.vendor?.username || !worker?._id) return;
        const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
        const db = getDatabase(app);
        const commentsRef = ref(db, `vendors-workers-comments/${worker?.vendor?.username}/${worker?._id}`);
        const unSubscribe = onChildAdded(commentsRef, (snapshot) => {
            const data = snapshot.val();
            if(data) {
                setCommentsList((commentsList)=>[data,...commentsList]);
            }
        });
        return()=>{
            unSubscribe();
        }
    },[worker?.vendor?.username, worker?._id]);


    return (
        <>
        <div className="w-full sm:w-[calc(50%-8px)] lg:w-[calc(33.3333%-12px)] bg-white rounded-[12px] p-[12px]">
            <div className="flex flex-nowrap justify-between items-center pb-[12px] border-b-[1px] border-grey-200">
                <div className="w-[50%]">
                    {worker?.fields && Array.isArray(worker?.fields) && worker?.fields.map((field,index)=>{
                        return <div key={`worker-field-${index}`} className="inline-block me-[8px]">
                                    <div className="inline-block me-[4px]">
                                        {FIELD_ICON(field,16,16,'fill-blue')}
                                    </div>
                                    <div className="inline-block text-blue font-[600] text-[16px] leading-[24px]">
                                        {i18n.language === 'ar' ? fields?.find(f=>f?.field?.code === field)?.field?.name?.ar : fields?.find(f=>f?.field?.code === field)?.field?.name?.en}
                                    </div>
                            </div>
                    })}
                    
                </div>
                <div className="w-[50%] text-end font-[500] text-[14px] text-grey-600">
                    {t('workers.since')} {moment(worker?.createdAt).format('DD/MM/YYYY')}
                </div>
            </div>
            <div className="pt-[12px]">
                <div className="text-[16px] text-grey-900 font-[500] leading-[24px] mb-[8px]">
                    <span className="text-blue text-[14px] font-[400] me-[4px]">
                        <img src="/assets/images/worker-name-icon.svg" alt="" className="inline-block me-[3px]" />
                        {t('workers.workerName')}
                    </span>
                    {worker?.name} - <span dir="ltr">{`[ ${worker?.username} ]`}</span>
                </div>

                <div className="text-[16px] text-grey-900 font-[500] leading-[24px] mb-[8px]">
                    <span className="text-blue text-[14px] font-[400] me-[4px]">
                        <img src="/assets/images/worker-city-icon.svg" alt="" className="inline-block me-[3px]" />
                        {t('workers.cityLabel')}
                    </span>
                    {i18n.language === 'ar' ? CITIES[worker?.city]?.ar : CITIES[worker?.city]?.en}
                </div>

                <div className="text-[16px] text-grey-900 font-[500] leading-[24px] mb-[8px]">
                    <span className="text-blue text-[14px] font-[400] me-[4px]">
                        <img src="/assets/images/worker-location-icon.svg" alt="" className="inline-block me-[3px]" />
                        {t('workers.districtLabel')}
                    </span>
                    {useDistrictNameByCityAndId(worker?.city,worker?.district,i18n.language) || "-"}
                </div>

                <div className="text-[16px] text-grey-900 font-[500] leading-[24px] mb-[8px]">
                    <span className="text-blue text-[14px] font-[400] me-[4px]">
                        <img src="/assets/images/worker-rating-icon.svg" alt="" className="inline-block me-[3px]" />
                        {t('workers.averageRating')}
                    </span>
                    {(
                        worker?.rateSum / (worker?.numberOfReviews === 0 ? 1 : worker?.numberOfReviews) || 0
                    ).toFixed(1)}
                </div>

                <div className="text-[16px] text-grey-900 font-[500] leading-[24px] mb-[8px]">
                    <span className="text-blue text-[14px] font-[400] me-[4px]">
                        <img src="/assets/images/worker-comment-icon.svg" alt="" className="inline-block me-[3px]" />
                        {t('workers.commentsCount')}
                    </span>
                    {commentsList?.length || 0}
                </div>

                <div className="flex flex-nowrap ltr:flex-wrap">
                    <div className="w-[50%] ltr:w-full text-[16px] text-grey-900 font-[500] leading-[24px] mb-[8px]">
                        <span className="text-blue text-[14px] font-[400] me-[4px]">
                            <img src="/assets/images/worker-request-icon.svg" alt="" className="inline-block me-[3px]" />
                            {t('workers.requestsCount')}
                        </span>
                        {worker?.totalRequestsCount || 0}
                    </div>

                    <div className="w-[50%] ltr:w-full text-[16px] text-grey-900 font-[500] leading-[24px] mb-[8px]">
                        <span className="text-blue text-[14px] font-[400] me-[4px]">
                            <img src="/assets/images/worker-done-icon.svg" alt="" className="inline-block me-[3px]" />
                            {t('workers.completedRequestsCount')}
                        </span>
                        {worker?.completedRequestsCount || 0}
                    </div>
                </div>

            </div>
            <div className="border-b-[1px] border-grey-200 mt-[4px] pt-[12px] pb-[12px] text-center">
                {worker?.suspendedTo && Date.parse(new Date(worker?.suspendedTo)) >= Date.parse(new Date())
                ? <div className="inline-block bg-grey-100 h-[22px] px-[8px] leading-[22px] rounded-[20px] me-[8px] text-grey-600 text-[12px] font-[500] opacity-50"><span className="bg-grey-400 w-[8px] h-[8px] rounded-full me-[4px] inline-block"></span>{t('workers.suspended')}</div>
                : <div className="inline-block bg-grey-50 h-[22px] px-[8px] leading-[22px] rounded-[20px] me-[8px] text-darkBlue text-[12px] font-[500]"><span className="bg-darkBlue w-[8px] h-[8px] rounded-full me-[4px] inline-block"></span>{t('workers.active')}</div>}

                {worker?.featuredSubscriptionValidTo && Date.parse(new Date(worker?.featuredSubscriptionValidTo)) >= Date.parse(new Date())
                ? <div className="inline-block bg-orange/10 h-[22px] px-[8px] leading-[22px] rounded-[20px] me-[8px] text-orange text-[12px] font-[500]"><span className="bg-orange w-[8px] h-[8px] rounded-full me-[4px] inline-block"></span>{t('workers.featured')}</div>
                : <div className="inline-block bg-grey-50 h-[22px] px-[8px] leading-[22px] rounded-[20px] me-[8px] text-grey-600 text-[12px] font-[500]"><span className="bg-grey-600 w-[8px] h-[8px] rounded-full me-[4px] inline-block"></span>{t('workers.normal')}</div>}
            
                {worker?.status === 'available'
                ? <div className="inline-block bg-blue/10 h-[22px] px-[8px] leading-[22px] rounded-[20px] me-[8px] text-blue text-[12px] font-[500]"><span className="bg-blue w-[8px] h-[8px] rounded-full me-[4px] inline-block"></span>{t('workers.available')}</div>
                : <div className="inline-block bg-danger/10 h-[22px] px-[8px] leading-[22px] rounded-[20px] me-[8px] text-danger text-[12px] font-[500]"><span className="bg-danger w-[8px] h-[8px] rounded-full me-[4px] inline-block"></span>{t('workers.unavailable')}</div>}
            </div>

            <Link to={`/${i18n?.language || 'ar'}/workers/${worker?.username}`} className="mt-[12px] h-[24px] flex flex-nowrap cursor-pointer">
                <div className="w-[50%] text-darkBlue text-[16px] font-[700] leading-[24px]">{t('workers.viewDetails')}</div>
                <div className="w-[50%] text-end"><img src="/assets/images/worker-details-icon.svg" alt="" className={`inline-block align-baseline ltr:rotate-180`} /></div>
            </Link>

            
        </div>

        </>
    )
}

export default WorkerCard;
